import React from "react";
import { FormattedMessage } from "react-intl";

// TODO: add dropdownFields and number fields
export default {
    // Trip: 9
    // [
    //      contractType, truckType, source, manualDistance,calculatedDistance
    //      helpersCount, scalesCount, tollStationGatesCount, status,
    // ]
    pickupTime: {
        name: "pickupTime",
        label: <FormattedMessage id="trip.pickup-time" />,
        type: "dateAndTime",
        validation: {
            required: false,
        },
    },
    contractType: {
        name: "contractType",
        label: <FormattedMessage id="trip.contract-type" />,
        type: "select",
        data: [
            { value: "monthly", text: "Monthly" },
            { value: "on_demand", text: "On Demand" },
            { value: "daily_rental", text: "Daily Rental" },
        ],
        validation: {
            required: true,
        },
    },
    truckType: {
        name: "truckType",
        label: <FormattedMessage id="trip.truck-type" />,
        type: "list",
        // selectedValue:{truckType}
    },
    source: {
        name: "source",
        label: <FormattedMessage id="trip-form.source-expatiation" />,
        type: "checkbox",
        validation: {
            required: false,
        },
    },
    returnable: {
        name: "returnable",
        label: <FormattedMessage id="trip-form.returnable-expatiation" />,
        type: "checkbox",
        confirmation: {
            title: <FormattedMessage id="trip-form.returnable-confirmation-title" />,
            content: <FormattedMessage id="trip-form.returnable-confirmation-content" />,
        },
        validation: {
            required: true,
        },
    },
    geofence: {
        name: "geofence",
        label: <FormattedMessage id="trip-form.geofencing-expatiation" />,
        type: "checkbox",
        confirmation: {
            title: <FormattedMessage id="trip-form.geofencing-confirmation-title" />,
            content: <FormattedMessage id="trip-form.geofencing-confirmation-content" />,
        },
        validation: {
            required: false,
        },
    },
    autoEnding: {
        name: "autoEnding",
        label: <FormattedMessage id="trip-form.driver-control-confirmation-content" />,
        type: "checkbox",
        confirmation: {
            title: <FormattedMessage id="trip-form.driver-control-confirmation-title" />,
            content: <FormattedMessage id="trip-form.driver-control-confirmation-content" />,
        },
        validation: {
            required: false,
        },
    },
    collectionShipmentAmounts: {
        name: "collectingNumberOffloadedUnits",
        label: <FormattedMessage id="trip-form.collectShipmentAmounts-expatiation" />,
        type: "checkbox",
        confirmation: {
            title: <FormattedMessage id="trip-form.collectShipmentAmounts-confirmation-title" />,
            content: (
                <FormattedMessage id="trip-form.collectShipmentAmounts-confirmation-content" />
            ),
        },
        validation: {
            required: false,
        },
    },
    helpersCount: {
        name: "helpersCount",
        label: <FormattedMessage id="trip.helpers-count" />,
        type: "number",
        validation: {
            required: false,
        },
    },

    // Pickup
    shipmentUnit: {
        name: "shipmentUnit",
        label: <FormattedMessage id="trip.shipment-unit" />,
        type: "select",
        data: [
            { value: "cases", text: "cases" },
            { value: "ton", text: "ton" },
            { value: "kg", text: "kg" },
            { value: "pallet", text: "pallet" },
            { value: "meter", text: "meter" },
        ],
        validation: {
            required: true,
        },
    },
    shipmentNumberOfUnits: {
        name: "shipmentNumberOfUnits",
        label: <FormattedMessage id="trip.shipment-number-of-units" />,
        type: "number",
        validation: {
            required: false,
        },
    },
    pickupAttachments: {
        name: "attachment",
        label: <FormattedMessage id="trip.pickup-attachment" />,
        type: "attachment",
        validation: {
            required: false,
        },
    },
    pickupPODNumber: {
        name: "podNumber",
        label: <FormattedMessage id="trip.pod-number" />,
        type: "number",
        validation: {
            required: false,
        },
    },
    pickupArrivalTime: {
        name: "arrivalTime",
        label: <FormattedMessage id="trip.pickup-arrived-at" />,
        type: "dateAndTime",
        validation: {
            required: false,
        },
    },
    pickupDepartureTime: {
        name: "departureTime",
        label: <FormattedMessage id="trip.pickup-left-at" />,
        type: "dateAndTime",
        validation: {
            required: false,
        },
    },
};
